// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb":"BreadCrumbs-BreadCrumb-module--bread-crumb--aqz7C","active":"BreadCrumbs-BreadCrumb-module--active--3W0TA"};